"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMplSystemExtrasProgramId = exports.getMplSystemExtrasProgram = exports.createMplSystemExtrasProgram = exports.MPL_SYSTEM_EXTRAS_PROGRAM_ID = void 0;
const errors_1 = require("../errors");
exports.MPL_SYSTEM_EXTRAS_PROGRAM_ID = 'SysExL2WDyJi9aRZrXorrjHJut3JwHQ7R9bTyctbNNG';
function createMplSystemExtrasProgram() {
    return {
        name: 'mplSystemExtras',
        publicKey: exports.MPL_SYSTEM_EXTRAS_PROGRAM_ID,
        getErrorFromCode(code, cause) {
            return (0, errors_1.getMplSystemExtrasErrorFromCode)(code, this, cause);
        },
        getErrorFromName(name, cause) {
            return (0, errors_1.getMplSystemExtrasErrorFromName)(name, this, cause);
        },
        isOnCluster() {
            return true;
        },
    };
}
exports.createMplSystemExtrasProgram = createMplSystemExtrasProgram;
function getMplSystemExtrasProgram(context, clusterFilter) {
    return context.programs.get('mplSystemExtras', clusterFilter);
}
exports.getMplSystemExtrasProgram = getMplSystemExtrasProgram;
function getMplSystemExtrasProgramId(context, clusterFilter) {
    return context.programs.getPublicKey('mplSystemExtras', exports.MPL_SYSTEM_EXTRAS_PROGRAM_ID, clusterFilter);
}
exports.getMplSystemExtrasProgramId = getMplSystemExtrasProgramId;
//# sourceMappingURL=mplSystemExtras.js.map